import { createAsyncThunk } from '@reduxjs/toolkit';
import { getClientPortalChats } from 'services/pod';

interface IProps {
  psaId: number;
  ticketId: number;
}

export const ThunkGetClientPortalChats = createAsyncThunk(
  'clientPortalChats/getClientPortalChats',
  ({ psaId, ticketId }: IProps) => getClientPortalChats(psaId, ticketId).then(r => r.data),
);
